"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _configuration = require("@/api/configuration");
var _order = require("@/api/order");
var _product = require("@/api/product");
var _staff = require("@/api/staff");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddProductOrderModal = _interopRequireDefault(require("./AddProductOrderModal.vue"));
var _FilterOrder = require("./FilterOrder.vue");
var _order2 = require("@/types/order");
var _warehouse = require("@/api/warehouse");
var ProductOrderForm = /*#__PURE__*/function (_Vue) {
  function ProductOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "statusForm", void 0);
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "orderProgress", void 0);
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "checkCustomerMonthBirthday", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "orderDetails", void 0);
    (0, _defineProperty2.default)(_this, "isLinkShopee", void 0);
    (0, _defineProperty2.default)(_this, "shopType", void 0);
    (0, _defineProperty2.default)(_this, "checkAmount", function (rule, value, callback) {
      // console.log("value ne", value);
      if (!value && value !== 0) {
        return callback(new Error("Field is required"));
      }
      setTimeout(function () {
        if (value < 0) {
          callback(new Error("Field is required"));
        } else {
          callback();
        }
      }, 1000);
    });
    (0, _defineProperty2.default)(_this, "checkShippingCharge", function (rule, value, callback) {
      console.log("value shipping ne", value);
      if (value == null || value === "") {
        return callback(new Error("Field is required"));
      }
      setTimeout(function () {
        if (value < 0) {
          callback(new Error("Field is required"));
        } else {
          callback();
        }
      }, 1000);
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", null);
    (0, _defineProperty2.default)(_this, "OrderType", _order2.OrderType);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "rules", {
      staffId: {
        required: true,
        message: "Field is required!",
        trigger: "submit"
      },
      shippingCharge: {
        required: true,
        message: "Field is required!",
        trigger: "submit",
        validator: _this.checkShippingCharge
      },
      totalShopeeFee: {
        required: true,
        message: "Field is required!",
        trigger: "submit",
        validator: _this.checkAmount
      },
      createdAt: {
        required: true,
        message: "Field is required!",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "summary", {
      totalPrice: 0,
      profit: 0
    });
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "OrderStatus", _FilterOrder.OrderStatus);
    (0, _defineProperty2.default)(_this, "ShippingChargeBy", _order2.ShippingChargeBy);
    (0, _defineProperty2.default)(_this, "tabShippingCharge", "");
    (0, _defineProperty2.default)(_this, "configVAT", {});
    return _this;
  }
  (0, _inherits2.default)(ProductOrderForm, _Vue);
  return (0, _createClass2.default)(ProductOrderForm, [{
    key: "showBirthdayCheckDiscount",
    get: function get() {
      var customerGroup = this.form.detailCustomer && this.form.detailCustomer.customer.customerGroup;
      return customerGroup && customerGroup.name == "Retail";
    }
  }, {
    key: "watchCustomerRank",
    value: function watchCustomerRank(val) {
      var _this2 = this;
      if (!val) {
        return;
      }
      var customerGroup = this.form.detailCustomer.customer.customerGroup;
      if (val && customerGroup && customerGroup.name == "Retail" && this.statusForm == "create") {
        this.dataTable.forEach(function (item) {
          _this2.$set(item, "tabDiscount", "percent");
          item.discountInput = item.discountInput || (val.customerRank ? val.customerRank.discountPercent : 0);
        });
      }
    }
  }, {
    key: "watchTabShippingCharge",
    value: function watchTabShippingCharge(data) {
      this.tabShippingCharge = data;
    }
  }, {
    key: "checkShowBirthdayDiscount",
    get: function get() {
      if (!this.form.detailCustomer) {
        return false;
      }
      if (this.form.detailCustomer.customer.customerRank && this.checkCustomerMonthBirthday && this.orderStatus != _FilterOrder.OrderStatus.Complete && this.type != _order2.OrderType.Gift) {
        return true;
      }
      return false;
    }
  }, {
    key: "dataTable",
    get: function get() {
      var _this3 = this;
      var summary = {
        totalPrice: 0,
        profit: 0
      };
      if (!this.form.products) {
        return [];
      }
      var publishIndex = this.form.products.findIndex(function (e) {
        return e.isPublished;
      });
      this.form.products.forEach(function (element, index) {
        var shippingCharge = 0;
        if (_this3.tabShippingCharge == _order2.ShippingChargeBy.Shiratori && (publishIndex == -1 && index == 0 || publishIndex == index)) {
          shippingCharge = _this3.form.shippingCharge || 0;
        }
        element.shippingCharge = shippingCharge;
        if (element.tabDiscount == "price") {
          element.realPrice = element.retailPrice - element.discountInput;
          element.discountAmount = element.discountInput;
          element.discountPercent = 0;
        } else {
          element.realPrice = element.retailPrice - element.retailPrice * element.discountInput / 100;
          element.discountPercent = element.discountInput;
          element.discountAmount = 0;
        }
        element.totalPrice = element.quantity * element.realPrice;
        element.profit = element.totalPrice - element.originPrice * element.quantity - shippingCharge;
        // summary
        summary.totalPrice += element.totalPrice;
        summary.profit += element.profit;
      });
      this.form.totalPrice = summary.totalPrice;
      this.form.profit = summary.profit;
      var checkPublish = this.form.products.find(function (e) {
        return e.isPublished;
      });
      if (checkPublish) {
        this.$emit("checkpublish:success", _order2.DeliveryFeeType.Publish);
      } else {
        this.$emit("checkpublish:success", _order2.DeliveryFeeType.NoPublish);
      }
      return this.form.products;
    }
  }, {
    key: "created",
    value: function created() {
      // this.fetchProduct();
      this.fetchStaffs();
      this.fetchConfigVAT();
      // this.form.shippingCharge = "-";
    }
  }, {
    key: "changeShippingCharge",
    value: function changeShippingCharge(value) {
      if (value == "") {
        this.form.shippingCharge = null;
      }
      console.log("value thay doi form ne", this.form.shippingCharge);
    }
    // xu ly chon lotNumber đối với đơn link shopee
  }, {
    key: "handleSelectLotNumber",
    value: function handleSelectLotNumber(val, item) {
      var lot = item.lotnumbers[val];
      // Lấy index có trong mảng sản phẩm
      var index = this.form.products.findIndex(function (p) {
        return p.id === item.id && p.lotNumber === item.lotNumber && p.expired === item.expired && p.dateOfManufacture === item.dateOfManufacture;
      });
      this.handleChangeProduct((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), lot), {}, {
        indexProduct: index >= 0 ? index : item.indexProduct
      }));
    }
    // lấy ds lotNumber của sản phẩm mỗi khi nhấn select
  }, {
    key: "fetchOrderLotNumber",
    value: function () {
      var _fetchOrderLotNumber = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(item) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _warehouse.warehouseApi.findGroup(item.id);
            case 2:
              res = _context.sent;
              this.$set(item, "lotnumbers", res.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOrderLotNumber(_x) {
        return _fetchOrderLotNumber.apply(this, arguments);
      }
      return fetchOrderLotNumber;
    }()
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this4 = this;
      _staff.staffApi.findAll().then(function (res) {
        return _this4.staffs = res.data.data;
      });
    }
  }, {
    key: "fetchConfigVAT",
    value: function () {
      var _fetchConfigVAT = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _configuration.configurationApi.findParam({
                param: _enum.ConfigurationParam.VatFactor
              });
            case 2:
              res = _context2.sent;
              this.configVAT = res.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchConfigVAT() {
        return _fetchConfigVAT.apply(this, arguments);
      }
      return fetchConfigVAT;
    }()
  }, {
    key: "handleAddProduct",
    value: function handleAddProduct() {
      this.$refs.productModal.handleCreate();
    }
  }, {
    key: "handleCheckDiscount",
    value: function handleCheckDiscount(item) {
      if (!this.form.detailCustomer || !this.form.detailCustomer.customer.customerRank) {
        return;
      }
      this.$set(item, "tabDiscount", "percent");
      if (item.isUseBirthdayDiscount) {
        item.discountInput = this.form.detailCustomer.customer.customerRank.birthdayDiscountPercent;
      } else {
        item.discountInput = this.form.detailCustomer.customer.customerRank.discountPercent || 0;
      }
    }
  }, {
    key: "handleChangeType",
    value: function handleChangeType(row) {
      var discount = 0;
      if (row.tabDiscount == "price") {
        discount = row.discountAmount;
      } else {
        discount = row.discountPercent;
      }
      this.$set(row, "discountInput", discount);
    }
  }, {
    key: "handleChangeShippingCharge",
    value: function handleChangeShippingCharge() {
      console.log("first");
      var shippingCharge = 0;
      if (this.orderProgress.shippingChargeBy == _order2.ShippingChargeBy.Shiratori) {
        shippingCharge = this.orderProgress.shippingChargeByShiratori;
      } else {
        shippingCharge = this.orderProgress.shippingChargeByCustomer;
      }
      this.$set(this.form, "shippingCharge", shippingCharge);
    }
  }, {
    key: "handleShippingCharge",
    value: function handleShippingCharge() {
      if (this.orderProgress.shippingChargeBy == _order2.ShippingChargeBy.Shiratori) {
        this.orderProgress.shippingChargeByShiratori = this.form.shippingCharge;
        this.orderProgress.shippingChargeByCustomer = 0;
      } else {
        this.orderProgress.shippingChargeByCustomer = this.form.shippingCharge;
        this.orderProgress.shippingChargeByShiratori = 0;
      }
    }
  }, {
    key: "handleChangeProduct",
    value: function handleChangeProduct(data) {
      var discountInput = 0;
      var tabDiscount = "";
      if (this.form.detailCustomer && this.form.detailCustomer.customer.customerRank && this.form.detailCustomer.customer.customerGroup && this.form.detailCustomer.customer.name == "Retail") {
        discountInput = this.form.detailCustomer.customer.customerRank.discountPercent || 0;
        tabDiscount = this.form.detailCustomer.customer.customerRank.discountPercent ? "percent" : "";
      }
      var maxQuantity = data.quantity - (data.sold || 0);
      var productData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data.product), {}, {
        lotNumber: data.lotNumber,
        expired: data.expired,
        dateOfManufacture: data.dateOfManufacture,
        productQuantity: this.type == _order2.OrderType.Consign ? maxQuantity : data.quantity,
        discountInput: discountInput,
        tabDiscount: tabDiscount,
        quantity: 1,
        totalPrice: 0,
        commissionAmount: 0,
        product: data.product,
        depositOrderDetailId: data === null || data === void 0 ? void 0 : data.id,
        maxQuantity: this.type == _order2.OrderType.Consign ? maxQuantity : null
      });
      // Nếu tồn tại indexProduct thì cập nhật lại sản phẩm
      if (data.indexProduct != undefined) {
        var duplicateIndex = this.form.products.findIndex(function (e, idx) {
          return idx !== data.indexProduct &&
          // Skip the current item
          e.id == data.product.id && e.lotNumber == data.lotNumber && e.expired == data.expired && e.dateOfManufacture == data.dateOfManufacture;
        });
        // If duplicate found, merge quantities and remove the current item
        if (duplicateIndex > -1) {
          var _updatedProducts = (0, _toConsumableArray2.default)(this.form.products);
          var currentQuantity = _updatedProducts[data.indexProduct].quantity || 1;
          // Add the current item's quantity to the duplicate item
          _updatedProducts[duplicateIndex] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _updatedProducts[duplicateIndex]), {}, {
            quantity: (_updatedProducts[duplicateIndex].quantity || 0) + currentQuantity
          });
          // Remove the current item
          _updatedProducts.splice(data.indexProduct, 1);
          // Update the products array
          this.$set(this.form, "products", _updatedProducts);
          return;
        }
        // No duplicate found, just update the current item
        var updatedProducts = (0, _toConsumableArray2.default)(this.form.products);
        var currentItem = updatedProducts[data.indexProduct];
        updatedProducts[data.indexProduct] = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentItem), productData), {}, {
          quantity: currentItem.quantity || 1 // Preserve current quantity
        });
        this.$set(this.form, "products", updatedProducts);
        return;
      }
      // check ton tai san pham và lotNumber giống lúc thêm thì tăng thêm số lượng
      var findIndex = this.form.products.findIndex(function (e) {
        return e.id == data.product.id && e.lotNumber == data.lotNumber && e.expired == data.expired && e.dateOfManufacture == data.dateOfManufacture;
      });
      if (findIndex > -1) {
        // If duplicate found, increase quantity
        var _updatedProducts2 = (0, _toConsumableArray2.default)(this.form.products);
        _updatedProducts2[findIndex] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _updatedProducts2[findIndex]), {}, {
          quantity: _updatedProducts2[findIndex].quantity + 1
        });
        this.$set(this.form, "products", _updatedProducts2);
      } else if (data.product) {
        // Add new product if no duplicate found
        this.$set(this.form, "products", [].concat((0, _toConsumableArray2.default)(this.form.products), [(0, _objectSpread2.default)((0, _objectSpread2.default)({}, productData), {}, {
          realPrice: data.product.retailPrice,
          indexProduct: this.form.products.length
        })]));
      }
    }
  }, {
    key: "handleRemoveProd",
    value: function () {
      var _handleRemoveProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.statusForm == "update" && item.detailId)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 3;
              return this.$confirm("Confirm delete product", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.form.products.splice(index, 1);
              _context3.next = 6;
              return _order.orderApi.deleteDetail(item.detailId);
            case 6:
              this.$notify({
                title: "Delete product",
                message: "Successfully",
                type: "success"
              });
              _context3.next = 10;
              break;
            case 9:
              this.form.products.splice(index, 1);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleRemoveProd(_x2, _x3) {
        return _handleRemoveProd.apply(this, arguments);
      }
      return handleRemoveProd;
    }()
  }, {
    key: "handleEditProd",
    value: function () {
      var _handleEditProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs.productModal.handleUpdate(index, item);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleEditProd(_x4, _x5) {
        return _handleEditProd.apply(this, arguments);
      }
      return handleEditProd;
    }()
  }, {
    key: "fetchProduct",
    value: function fetchProduct(search) {
      var _this5 = this;
      this.loading = true;
      _product.productApi.findAll({
        limit: 50,
        page: 1,
        search: search
      }).then(function (res) {
        return _this5.products = res.data.products;
      }).finally(function () {
        return _this5.loading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], ProductOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "statusForm", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "orderProgress", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "checkCustomerMonthBirthday", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "compare", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "orderDetails", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "isLinkShopee", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "shopType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.detailCustomer.customer", {
  deep: true,
  immediate: true
})], ProductOrderForm.prototype, "watchCustomerRank", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("orderProgress.shippingChargeBy", {
  deep: true
})], ProductOrderForm.prototype, "watchTabShippingCharge", null);
ProductOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddProductOrderModal: _AddProductOrderModal.default
  }
})], ProductOrderForm);
var _default = exports.default = ProductOrderForm;